module.exports = __webpack_public_path__ + "static/media/1_A1_24.b21a9638.png";